import { CategoryName, DisplayModeName } from '@infotech-soe/metaschema';

import IIntlService from '../../intl/IIntlService';
import IntlService from '../../intl/IntlService';
import DatasetTreeNode from '../dataset-tree/logical/DatasetTreeNode';
import DisplayModeDatasetTreeNode from '../dataset-tree/logical/DisplayModeDatasetTreeNode';

import CategoryIntlProvider from './CategoryIntlProvider';

/**
 * {@link CategoryIntlProvider} implementation for display modes.
 */
class DisplayModeIntlProvider implements CategoryIntlProvider {
  private readonly intlService: IIntlService;
  constructor(
    private categoryName: CategoryName,
    private displayModeName: DisplayModeName
  ) {
    this.intlService = new IntlService();
  }

  public getCategoryTitle(): Promise<string> {
    return this.intlService.getDisplayModeTitle(
      this.categoryName,
      this.displayModeName
    );
  }

  public getDatasetTitle(node: DatasetTreeNode): Promise<string> {
    if (!(node instanceof DisplayModeDatasetTreeNode)) {
      return Promise.reject('Node does not belong to a display mode');
    }

    return this.intlService.getDisplayModeDatasetTitle(
      this.categoryName,
      this.displayModeName,
      node.getDatasetName()
    );
  }
}

export default DisplayModeIntlProvider;
